module.exports = __webpack_public_path__ + "img/kasa.vestok.hr.75e704c5.png";